import { Instagram, Linkedin, Twitter, MapPin, Mail, Phone } from "lucide-react";

const QUICK = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Events", id: "events" },
  { label: "Schedule", id: "schedule" },
  { label: "Guidelines", id: "guidelines" },
  { label: "Team", id: "team" },
  { label: "Register", id: "register" },
];

const COORDINATORS = [
  { name: "Ms. Rohita", phone: "+91 97420 97540" },
  { name: "Ms. Rohini", phone: "+91 81972 83416" },
  { name: "Mr. Mihir", phone: "+91 99818 39207" },
];

export default function Footer() {
  const go = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="footer" className="relative bg-[#080808] border-t border-[#B8873B]/25 pt-14 sm:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12 grid md:grid-cols-12 gap-8 sm:gap-10">
        <div className="md:col-span-4">
          <div className="font-display tracking-[0.4em] text-lg uppercase text-marble">Tradella</div>
          <p className="mt-4 text-white/55 text-sm font-light leading-relaxed max-w-md">
            Harvest International School&apos;s flagship business & commerce fest —
            where strategy, negotiation, innovation and ambition collide.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {[
              { Icon: Instagram, href: "https://www.instagram.com/tradella.harvest/" },
              { Icon: Linkedin, href: "#" },
              { Icon: Twitter, href: "#" },
            ].map(({ Icon, href }, i) => (
              <a
                key={i}
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 border border-[#B8873B]/40 grid place-items-center text-[#B8873B] hover:border-[#B8873B] transition-colors"
              >
                <Icon size={15} />
              </a>
            ))}
          </div>
          <a
            href="https://www.instagram.com/tradella.harvest/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-handle"
            className="mt-4 inline-block text-[11px] tracking-[0.35em] uppercase text-white/55 hover:text-[#B8873B] transition-colors"
          >
            @tradella.harvest
          </a>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#B8873B] mb-4">Navigate</div>
          <ul className="grid grid-cols-2 md:block gap-y-2.5 md:space-y-2.5">
            {QUICK.map((q) => (
              <li key={q.id}>
                <a
                  href={`#${q.id}`}
                  onClick={go(q.id)}
                  data-testid={`footer-link-${q.id}`}
                  className="text-sm text-white/55 hover:text-[#B8873B] transition-colors py-1 inline-block"
                >
                  {q.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-5">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#B8873B] mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex gap-3"><MapPin size={15} className="text-[#B8873B] mt-0.5 shrink-0" /> <span>Harvest International School, Kodathi</span></li>
            <li className="flex gap-3"><Mail size={15} className="text-[#B8873B] mt-0.5 shrink-0" /> <a href="mailto:tradella.harvest@gmail.com" className="break-all hover:text-[#B8873B] transition-colors">tradella.harvest@gmail.com</a></li>
          </ul>

          <div className="mt-6 text-[10px] tracking-[0.4em] uppercase text-[#B8873B] mb-3">Event Coordinators</div>
          <ul className="space-y-2 text-sm">
            {COORDINATORS.map((c) => (
              <li key={c.name} className="flex items-center justify-between gap-4 border-b border-[#B8873B]/10 py-1.5" data-testid={`coordinator-${c.name.replace(/\s+/g, "-").toLowerCase()}`}>
                <span className="text-white/70">{c.name}</span>
                <a href={`tel:${c.phone.replace(/\s+/g, "")}`} className="flex items-center gap-2 text-white/55 hover:text-[#B8873B] transition-colors">
                  <Phone size={12} className="text-[#B8873B]" />
                  <span>{c.phone}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12 mt-10 sm:mt-12 pt-6 border-t border-[#B8873B]/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-center">
        <div className="text-[10px] tracking-[0.4em] uppercase text-white/35">
          © 2026 · Tradella · All Rights Reserved
        </div>
        <div className="text-[10px] tracking-[0.4em] uppercase text-[#B8873B]/60 font-display italic">
          Forge Your Fortune
        </div>
      </div>
    </footer>
  );
}
